import React from "react";
import classNames from "classnames";
import makeStyles from "@mui/styles/makeStyles";
import type { Styles } from "@mui/styles";
import type { Theme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import GridContainer from "@/components/Grid/GridContainer";
import GridItem from "@/components/Grid/GridItem";
import Card from "@/components/Card/Card";
import CardBody from "@/components/Card/CardBody";
import styles from "@/styles/jss/nextjs-material-kit-pro/pages/componentsSections/preFooter.js";
import { simpleForm as NewsletterForm } from "@/components/Importable/Newsletter";

interface SubscriptionBannerProps {
    sidebarOffset?: number;
}

// Legacy JSS style object; cast to compatible Styles type for JSS
const useStyles = makeStyles(
    styles as unknown as Styles<Theme, object, string>,
);

export default function SubscriptionBanner({
    sidebarOffset = 0,
}: SubscriptionBannerProps) {
    const classes = useStyles();
    return (
        <div
            data-select-target="Newsletter Signup"
            className={classNames(
                classes.subscribeLine,
                classes.subscribeLineImage,
            )}
            style={{
                backgroundColor: "#2c4a63",
                marginLeft: sidebarOffset ? `${sidebarOffset}px` : 0,
                transition: "margin-left 0.3s ease",
            }}
        >
            <div className={classes.container}>
                <GridContainer>
                    <GridItem
                        xs={12}
                        sm={9}
                        md={7}
                        className={classNames(classes.mlAuto, classes.mrAuto)}
                        style={{
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            padding: "0 20px",
                            borderRadius: "8px",
                        }}
                    >
                        <div className={classes.textCenter}>
                            <h3 className={classes.title}>
                                Stay Ahead of Regulatory Changes
                            </h3>
                            <p className={classes.description}>
                                Subscribe to our newsletter for monthly updates
                                on global compliance news and upcoming events.
                            </p>
                        </div>
                        <Card raised className={classes.card}>
                            <CardBody className={classes.cardBody}>
                                <NewsletterForm source="subscription-banner" />
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
        </div>
    );
}
